// extracted by mini-css-extract-plugin
export var container = "related-list-module--container--ROgn8";
export var header = "related-list-module--header--D4us4";
export var list = "related-list-module--list--B5S3L";